import React from 'react'
import {Toolbar} from '../../layout/Toolbar/Toolbar';
import { CalificacionesFuncionario } from '../../components/Calificaciones/CalificacionesFuncionario';
export const PrecalificacionesDelFuncionario = () => {

    let toolbarEnlaces = [
        {
          muted: "true",
          to: "/",
          title: "Home",
          bullet: "false",
        },
        {
          muted: "true",
          to: "",
          title: "",
          bullet: "true",
        },
        {
          muted: "false",
          to: null,
          title: "Procesos del Funcionario",
          bullet: "false",
        },
      ];

    return (
        <>
        <div
            className="content d-flex flex-column flex-column-fluid"
            id="kt_content"
        >
            <Toolbar title="Ver Historial de Procesos" enlaces={toolbarEnlaces}></Toolbar>
            <div className="post d-flex flex-column-fluid" id="kt_post">
            <div className="container-xxl">
                <div className="row gy-5 g-xl-8">
                <div className="col-xl-12">
                    <div className="card">
                        <div className="card-body vh-75">
                            <div className='row'>
                                <div className='col-md-12'>
                                    <CalificacionesFuncionario/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
        </>
    )
}
